import { render, staticRenderFns } from "./miles-statistic.vue?vue&type=template&id=37c73ef1&scoped=true"
import script from "./miles-statistic.vue?vue&type=script&lang=js"
export * from "./miles-statistic.vue?vue&type=script&lang=js"
import style0 from "./miles-statistic.vue?vue&type=style&index=0&id=37c73ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c73ef1",
  null
  
)

export default component.exports